"use strict";
exports.__esModule = true;
exports.InstalledAppsDocument = void 0;
var InstalledAppsDocument = /** @class */ (function () {
    function InstalledAppsDocument(id, org_id, app_id, name, icon, is_installed, created_on, created_by, updated_on, updated_by, configuration, accounts) {
        this.id = id;
        this.org_id = org_id;
        this.app_id = app_id;
        this.name = name;
        this.icon = icon;
        this.is_installed = is_installed;
        this.created_on = created_on;
        this.created_by = created_by;
        this.updated_on = updated_on;
        this.updated_by = updated_by;
        this.configuration = configuration;
        this.accounts = accounts;
    }
    InstalledAppsDocument.fromJSON = function (json) {
        var integration = new InstalledAppsDocument('', '', '', '', '', true, 0, '', 0, '', {});
        if (json) {
            integration.id = json.id ? json.id : 0;
            integration.org_id = json.org_id ? json.org_id : '';
            integration.app_id = json.app_id ? json.app_id : '';
            integration.name = json.name ? json.name : '';
            integration.icon = json.icon ? json.icon : '';
            integration.is_installed = json.is_installed !== undefined ? json.is_installed : false;
            integration.created_by = json.created_by ? json.created_by : '';
            integration.updated_by = json.updated_by ? json.updated_by : '';
            integration.created_on = json.updated_on ? json.updated_on : 0;
            integration.updated_on = json.updated_on ? json.updated_on : 0;
            integration.configuration = json.recommended || {};
            integration.accounts = json.accounts || [];
        }
        return integration;
    };
    return InstalledAppsDocument;
}());
exports.InstalledAppsDocument = InstalledAppsDocument;
